module.exports = __webpack_public_path__ + "img/404.218304fa.png";